import { useContext } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { RecordContext } from "../../../components/record/Record";
import { DimensionScoresGrid } from "./DimensionScoresGrid";
import { PsyEvaluationScoresTable } from "./scores-table/PsyEvaluationScoresTable";
import { resolveTrailingColumns } from "./scores-table/resolveTrailingColumns";
import { useScoresData } from "../useScoresData";

export const PsyEvaluationScores = () => {
	const recordContext = useContext(RecordContext);
	const instrumentResponseId = recordContext?.id as string;
	const { scores, formatedFields, levelColors, isLoading, isError } = useScoresData(instrumentResponseId);

	const scoringNotes = recordContext?.item?.instrument_id?.scoring_notes;
	const trailingColumns = resolveTrailingColumns(recordContext?.item?.instrument_id?.id);

	if (isLoading) return <CircularProgress sx={{ mt: 5 }} color="secondary" />;
	if (isError) return <Typography sx={{ mt: 5, textAlign: "center" }}>Erro ao carregar cotações</Typography>;
	if (scores.length === 0) return <Typography sx={{ mt: 5, textAlign: "center", color: "text.secondary" }}>Sem cotações disponíveis</Typography>;

	return (
		<>
			<Box display="flex" flex={1} flexDirection="row" gap={6} sx={{ backgroundColor: "#fff" }} flexWrap="wrap">
				<PsyEvaluationScoresTable scores={scores} formatedFields={formatedFields} levelColors={levelColors} trailingColumns={trailingColumns} />
				{scoringNotes && (
					<Box sx={{ px: { xs: 4, sm: 0 } }}>
						<Typography variant="subtitle1" color="primary" fontWeight="bold" pb={1} pt={4}>
							Notas de cotação
						</Typography>
						<Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
							{scoringNotes}
						</Typography>
					</Box>
				)}
			</Box>
			<DimensionScoresGrid
				scores={scores}
				formatedFields={formatedFields}
			/>
		</>
	);
};
